import type { TFunction } from 'i18next'

import {
	Operators,
	ValueEditorType,
	ValueType,
} from '@/shared/components/query-builder'

export const getFilterFields = (t: TFunction) => [
	{
		value: 'optimization_group_id',
		label: t('optimization_group'),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.multiselect,
		operations: [
			Operators.IS,
			Operators.IS_NOT,
			Operators.IN,
			Operators.NOT_IN,
			Operators.IS_EMPTY,
			Operators.IS_NOT_EMPTY,
		],
		enum: [],
	},
	{
		value: 'anchor_type',
		label: t('field_schema_anchor_type', { ns: 'fields' }),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.multiselect,
		operations: [Operators.IN, Operators.NOT_IN],
		enum: [],
	},
	{
		value: 'name',
		label: t('field_schema_strategy_name', {
			ns: 'fields',
			defaultValue: 'Strategy name',
		}),
		valueType: ValueType.string,
		valueEditorType: ValueEditorType.text,
		enum: [],
	},
]
